var t={anchor:"styles_anchor__w5ajF",button:"styles_button__Q5ytc",item:"styles_item__YIhd9",content:"styles_content__GGlDr",text:"styles_text__wEz2N",sub_text:"styles_sub_text__6DaAB"};export{t as default};
